
import { Options, Vue } from "vue-class-component";

@Options({})
export default class OrderDetail extends Vue { 
  activated() {
    
  }  
}
